<div class="popup-container">

<div style="display:inline">{{ shortenedComment }}</div>
<button *ngIf="btnVisible" class='b2' (click)="openOrders($event)">...</button>
</div>